import { FeatureCollection } from 'geojson'
import jmespath from 'jmespath'
import { get, sumBy } from 'lodash'

const getGeojsonSearch = (geojson: FeatureCollection, args: string) => {
  return jmespath.search(geojson.features, args)
}

const getSelectedPropertiesArgs = (aggregateKeys: string[]) => {
  if (aggregateKeys?.length < 1) return 'properties: properties'

  // INFO: map select properties from geojson features' properties
  const mapSelectPropertyKeys = aggregateKeys
    .map((key) => `"${key}": properties."${key}"`)
    .join(', ')

  return `properties: { ${mapSelectPropertyKeys} }`
}

const getSearchArgs = (
  mscode: string,
  aggregate: string,
  aggregateKeys: string[]
) => {
  const key = `MS_${aggregate.replace(':', '-')}`

  const selectedPropertiesArgs = getSelectedPropertiesArgs(aggregateKeys)

  const args = `[?(properties."${key}"=='${mscode}')].{ ${selectedPropertiesArgs} }`

  return args
}

type Feature = {
  properties: { mscode: string }
  sourceLayer: string
}

export const getBoundaryFeature = (
  geojson: FeatureCollection,
  feature: Feature,
  aggregateKeys: string[]
) => {
  // INFO: get mscode, msname from base-map layer feature
  const mscode = get(feature, 'properties.mscode')
  const msname = get(feature, 'properties.msname')

  if (!mscode) return

  // INFO: sourceLayer from base-map layer
  const { sourceLayer } = feature
  const args = getSearchArgs(mscode, sourceLayer, aggregateKeys)

  const properties = getGeojsonSearch(geojson, args)

  // INFO: For click outside of boundary (click on base-map layer)
  if (properties.length < 1) return

  // INFO: Add Location count, Name, Total properties to feature properties
  const totalAggregateProperties = {
    'Location count': properties.length,
    Name: msname
  }
  aggregateKeys.forEach((value) => {
    totalAggregateProperties[`Total ${value}`] = sumBy(
      properties,
      `properties.${value}`
    )
  })

  return {
    ...feature,
    properties: totalAggregateProperties
  }
}
